// ui validator not allowing to set "negative" attainment metrics
import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { metricFormStrings } from "@gtmhub/okrs/metrics/utils";
import { FormFields } from "@webapp/okrs/metrics/components/create-metric-form/create-metric-form.component";
import { MetricTargetOperator } from "@webapp/okrs/metrics/models/metric.models";

export function initialValueValidator(): ValidatorFn {
  return (form: FormGroup<FormFields>): ValidationErrors | null => {
    const initialValue: number = form.controls.initialValue.value;
    const manualType: string = form.controls.type.value?.manualType;
    const targetOperator: MetricTargetOperator = form.controls.type.value?.targetOperator;
    const targetValue: number = form.controls.target.value;

    const isManualTypeDoubleOrEmpty = manualType === metricFormStrings.double || manualType === metricFormStrings.empty;
    const shouldNotShowErr = initialValue === null || targetValue === null;

    if (isManualTypeDoubleOrEmpty && shouldNotShowErr) {
      return null;
    }

    // The initial value should be lower than the target value
    if (isManualTypeDoubleOrEmpty && targetOperator === "at_least" && initialValue >= targetValue) {
      return {
        initialLowerThanTarget: "initial-lower-than-target",
      };
    }

    // The initial value should be greater than the target
    if (isManualTypeDoubleOrEmpty && targetOperator === "at_most" && initialValue <= targetValue) {
      return {
        initialGreaterThanTarget: "initial-greater-than-target",
      };
    }

    return null;
  };
}

export function criticalValidator(): ValidatorFn {
  return (form: FormGroup<FormFields>): ValidationErrors | null => {
    const criticalValue: number = form.controls.critical.value;
    const manualType: string = form.controls.type.value?.manualType;
    const targetOperator: MetricTargetOperator = form.controls.type.value?.targetOperator;
    const targetValue: number = form.controls.target.value;
    const useCritical: boolean = form.controls.useCritical.value;

    const isManualTypeDoubleOrEmpty = manualType === metricFormStrings.double || manualType === metricFormStrings.empty;
    const shouldNotShowErr = useCritical ? targetValue === null || criticalValue === null : false;

    if (isManualTypeDoubleOrEmpty && shouldNotShowErr) {
      return null;
    }

    // The critical value should be lower than the target
    if (
      isManualTypeDoubleOrEmpty &&
      targetOperator === "should_stay_above" &&
      criticalValue !== null &&
      typeof criticalValue !== "undefined" &&
      criticalValue >= targetValue
    ) {
      return {
        criticalLowerThanTarget: "critical-lower-than-target",
      };
    }

    // The critical value should be greater than the target
    if (
      isManualTypeDoubleOrEmpty &&
      targetOperator === "should_stay_below" &&
      criticalValue !== null &&
      typeof criticalValue !== "undefined" &&
      criticalValue <= targetValue
    ) {
      return {
        criticalGreaterThanTarget: "critical-greater-than-target",
      };
    }

    return null;
  };
}
